// Configurazioni di BoardList: cosa cambia tra annunci (bacheca) e comunicazioni.
import { removeAnnouncement, markAnnouncementAsRead } from '../../services/announcementServices';
import { removeCommunication, markCommunicationAsRead } from '../../services/communicationServices';

export const announcementConfig = {
    remove: removeAnnouncement,
    markAsRead: markAnnouncementAsRead,
    viewKey: 'announcement_id',
    labels: {
        heading: 'Annunci pubblicati',
        hideRead: 'Nascondi già letti',
        confirmRemove: (title) => `Eliminare l'annuncio «${title}»?`,
        removed: 'Annuncio rimosso con successo.',
        removeError: 'Errore nella rimozione dell\'annuncio.',
        markedRead: 'Annuncio segnato come letto.',
        markReadError: 'Errore nel segnare come letto.',
        noViews: 'Nessuno ha ancora visualizzato questo annuncio.',
    },
};

export const communicationConfig = {
    remove: removeCommunication,
    markAsRead: markCommunicationAsRead,
    viewKey: 'communication_id',
    labels: {
        heading: 'Comunicazioni inviate',
        hideRead: 'Nascondi già lette',
        confirmRemove: (title) => `Eliminare la comunicazione «${title}»?`,
        removed: 'Comunicazione rimossa con successo.',
        removeError: 'Errore nella rimozione della comunicazione.',
        markedRead: 'Comunicazione segnata come letta.',
        markReadError: 'Errore nel segnare come letta.',
        noViews: 'Nessuno ha ancora visualizzato questa comunicazione.',
    },
};
